import React, { useContext } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router';
import { PropsFromRedux } from '.';
// import cartImg from '../../../../assets/images/greencart.svg';
import PersonalShopperContext from '../../../../context/PersonalShopperContex/PersonalShopperContex';
import { API_KEYS } from '../../../../interfaces/api';
import { BeatLoader } from '../../../Spinners/Spinner';


interface Props extends PropsFromRedux {}

const DeleteShopperItem: React.FC<Props> = ({ 
  hideModal,
  // showModal,
  modal,
  resetApi,
  getHistory,
  // historyState,
  deleteItem,
  deleteItemState
 }) => {

  const history = useHistory();
  const location = useLocation();
  const { shopperData, setShopperData } = useContext(PersonalShopperContext);
    
  const modalProps = modal?.ownProps?.itemDetails;

  React.useEffect(() => () => {
    resetApi(API_KEYS.DELETE_PERSONAL_SHOPPING_ITEM);
},
[resetApi]);

  const closeModal = () => {
    hideModal();
  }
  
const deleteMe = () => {
    deleteItem(modalProps)
}

  React.useEffect(() => {
    if(!deleteItemState?.loading && deleteItemState?.success){
      hideModal();
    }
  },[!deleteItemState?.loading, deleteItemState?.success, hideModal])

  return( 
    <div className="w-full px-4 bg-white lg:px-12 py-12 relative">
        <button type="button" aria-label="Close" onClick={closeModal}>
            <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
        </button>
        <div className="w-full my-6">
            <h2 className="mb-1 text-sm font-medium text-gray-400">Delete Item</h2>
            <p className=" w-96 md:text-sm text-xs text-black">Are you sure you want to delete this product from the list? </p>
        </div>

        <div className="w-full flex justify-end">
          <button className="bg-gray-300 font-medium text-sm rounded text-black p-4  m-2" type="button"
          onClick={() => closeModal()} 
          >No</button>
          <button className="bg-secondary font-medium text-sm rounded text-white p-2 m-2" 
          onClick={() => deleteMe()}
          // onClick={() => 
            
          //   deleteShoppingItem()} 
          type="button"
          >
            {deleteItemState?.loading ? <BeatLoader color="white" /> : 'Yes, Delete'}
            </button>
        </div>
     
  </div>
  );
  // </ModalWrapper>
};

export default DeleteShopperItem;